/**
 * @generated SignedSource<<77b1bf955f575991661c52babdc8e6e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserUpdateInput = {
  id: string;
  joinedAt?: any | null;
  name?: string | null;
  password?: string | null;
  slackId?: string | null;
};
export type UserUpdatePasswordDialog_userUpdateMutation$variables = {
  input: UserUpdateInput;
};
export type UserUpdatePasswordDialog_userUpdateMutation$data = {
  readonly userUpdate: {
    readonly " $fragmentSpreads": FragmentRefs<"UserUpdatePasswordDialog_user">;
  };
};
export type UserUpdatePasswordDialog_userUpdateMutation = {
  response: UserUpdatePasswordDialog_userUpdateMutation$data;
  variables: UserUpdatePasswordDialog_userUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserUpdatePasswordDialog_userUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "userUpdate",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserUpdatePasswordDialog_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserUpdatePasswordDialog_userUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "userUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a5131989fe89ce1cfe3b2038d2ad6d7",
    "id": null,
    "metadata": {},
    "name": "UserUpdatePasswordDialog_userUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation UserUpdatePasswordDialog_userUpdateMutation(\n  $input: UserUpdateInput!\n) {\n  userUpdate(input: $input) {\n    ...UserUpdatePasswordDialog_user\n    id\n  }\n}\n\nfragment UserUpdatePasswordDialog_user on User {\n  id\n}\n"
  }
};
})();

(node as any).hash = "edbd72656de864e4da36d6193dc3d3c5";

export default node;
